'use client'

import { AlertTriangle } from '@untitledui/icons'

import { Dialog, Modal, ModalOverlay } from '@/components/shared/ui/application/modals/modal'
import { Button } from '@/components/shared/ui/base/buttons/button'
import { cx } from '@/utils/cx'

export interface ConfirmDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description: string
  confirmLabel?: string
  cancelLabel?: string
  destructive?: boolean
  isLoading?: boolean
  onConfirm: () => void
}

export function ConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel = 'Bevestigen',
  cancelLabel = 'Annuleren',
  destructive = false,
  isLoading = false,
  onConfirm,
}: ConfirmDialogProps) {
  return (
    <ModalOverlay isOpen={open} onOpenChange={onOpenChange} isDismissable={!isLoading}>
      <Modal>
        <Dialog>
          <div className="bg-primary w-full max-w-md rounded-xl p-6 text-left shadow-xl">
            <div className="flex items-start gap-4">
              <div
                className={cx(
                  'flex size-10 shrink-0 items-center justify-center rounded-full',
                  destructive ? 'bg-error-secondary' : 'bg-secondary'
                )}
              >
                <AlertTriangle className={cx('size-5', destructive ? 'text-fg-error-primary' : 'text-fg-quaternary')} />
              </div>
              <div className="mt-0.5 flex-1">
                <h3 className="text-primary text-md font-semibold">{title}</h3>
                <p className="text-tertiary mt-1 text-sm">{description}</p>
              </div>
            </div>

            <div className="mt-6 flex justify-end gap-3">
              <Button color="secondary" size="sm" isDisabled={isLoading} onClick={() => onOpenChange(false)}>
                {cancelLabel}
              </Button>
              <Button
                color={destructive ? 'primary-destructive' : 'primary'}
                size="sm"
                isLoading={isLoading}
                onClick={onConfirm}
              >
                {confirmLabel}
              </Button>
            </div>
          </div>
        </Dialog>
      </Modal>
    </ModalOverlay>
  )
}
